const wrappers = document.querySelectorAll('.carousel-wrapper');


wrappers.forEach(wrapper => {

    const carousel = wrapper.querySelector('.carousel');
    const prevBtn = wrapper.querySelector('.carousel-button.prev');
    const nextBtn = wrapper.querySelector('.carousel-button.next');

    function getVisibleItems() {
        const width = window.innerWidth;
        if (width >= 1024) return 3;
        // if (width >= 600) return 3;
        return 1;
    }

    let currentIndex = 0;

    function updateCarousel() {
        const itemCount = carousel.children.length;
        const itemsPerView = getVisibleItems();
        const maxIndex = itemCount - itemsPerView;
        if (currentIndex < 0) currentIndex = maxIndex;
        if (currentIndex > maxIndex) currentIndex = 0;
        const itemWidth = carousel.querySelector('.carousel-item').offsetWidth;// + 10;
        carousel.style.transform = `translateX(-${currentIndex * itemWidth}px)`;
    }

    function getMovement() {
        const width = window.innerWidth;
        if (width >= 1024) return 3;
        // if (width >= 600) return 3;
        return 1;
    }

    prevBtn.addEventListener('click', () => {
        currentIndex -= getMovement();
        updateCarousel();
    });

    nextBtn.addEventListener('click', () => {
        currentIndex += getMovement();
        updateCarousel();
    });

    window.addEventListener('resize', () => {
        updateCarousel();
    });

// počáteční nastavení
    window.addEventListener('load', () => {
        updateCarousel();
    });
})
